export const formatNaturalDemand = (naturalDemand: number[][]) => {
    return {
        monthly: naturalDemand[0],
        weekly: naturalDemand[1],
        daily: naturalDemand[2],
    };
};
